import e from"react";import l from"classnames";const t=({className:t,fillContainer:s,size:a})=>e.createElement("div",{className:l("skeleton rounded-full",{"w-full h-full":s},t),style:{height:a,width:a}});export{t as SkeletonCircle};
